module.exports = __webpack_public_path__ + "static/media/offline_capabilities.e674dfca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/offline_capabilities.svg
// module id = 408
// module chunks = 0